export const getAppConfig = state => state.systemData.appConfig;
export const getHeaderProps = state => state.systemData.api.headerProps;
export const getRequestProps = state => state.systemData.api.requestProps;
